export default __webpack_public_path__ + "static/media/aboutFlow.e0a228c0.png";